import { Reducer } from 'redux';

import { QuestionActivityForViewerLoadAction } from '../../domains/questionActivityForViewer/actions.types';

import { QuestionActivityForViewerLifecycle } from './types';

const initialState: QuestionActivityForViewerLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<QuestionActivityForViewerLifecycle, QuestionActivityForViewerLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'QUESTION_ACTIVITY_FOR_VIEWER.LOAD_PENDING':
      return { ...initialState, pending: true };
    case 'QUESTION_ACTIVITY_FOR_VIEWER.LOAD_FULFILLED':
      return { ...initialState, fulfilled: action.payload.entities.networkViewerQuestionActivity };
    case 'QUESTION_ACTIVITY_FOR_VIEWER.LOAD_REJECTED':
      return { ...initialState, rejected: action.payload.error };
    default:
      return state;
  }
};

export default reducer;
